/* ============================================================
   SUPPLEMENT WORLD — Product Page Interactions
   Loads on product.supplement-world template
   ============================================================ */
(function () {
  'use strict';

  /* ────────── Pack size + purchase mode + CTA sync ────────── */
  let selectedPack = { qty: 6, price: 107.82, label: '6 Pack', compare: 179.70 };
  // Default to 'subscription' only when the Subscribe box actually rendered
  // (i.e. the current variant is attached to one or more Appstle selling plans).
  // Otherwise fall back to one-time so ATC never posts an invalid selling_plan.
  let purchaseMode = document.querySelector('.sub-wrap') ? 'subscription' : 'onetime';
  let cartQty = 1;

  function el(id) { return document.getElementById(id); }

  // Format a numeric amount (in base-currency DOLLARS) using the shop's money format
  // string. Falls back to "$X.XX" if no format is exposed.
  function fmt(dollars) {
    const n = Number(dollars) || 0;
    const format = (window.swShop && window.swShop.moneyFormat) || '${{amount}}';
    const withDecimals = n.toFixed(2);
    const noDecimals   = Math.round(n).toString();
    return format
      .replace(/\{\{\s*amount_no_decimals(_with_(?:comma|space)_separator)?\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount(_with_(?:apostrophe|period)_separator)?\s*\}\}/g, withDecimals);
  }

  function syncPrices() {
    const subMult = 0.80;
    const subPrice = +(selectedPack.price * subMult).toFixed(2);
    const subPerDay = +(subPrice / 30 / selectedPack.qty).toFixed(2);
    const otPerDay = +(selectedPack.price / 30 / selectedPack.qty).toFixed(2);

    if (el('subPrice')) el('subPrice').textContent = fmt(subPrice);
    if (el('subCompare')) el('subCompare').textContent = fmt(selectedPack.compare);
    if (el('subPerday')) el('subPerday').textContent = `${fmt(subPerDay)}/day`;
    if (el('otPrice')) el('otPrice').textContent = fmt(selectedPack.price);
    if (el('otCompare')) el('otCompare').textContent = selectedPack.compare > selectedPack.price ? fmt(selectedPack.compare) : '';
    if (el('otPerday')) el('otPerday').textContent = `${fmt(otPerDay)}/day`;
    if (el('otSub')) el('otSub').textContent = `${selectedPack.label} delivered once`;

    const packLabel = document.querySelector('.pack-label strong');
    if (packLabel) packLabel.textContent = selectedPack.label;

    const ctaPrice = purchaseMode === 'subscription' ? subPrice : selectedPack.price;
    // Don't overwrite the Sold Out text — if Liquid rendered a disabled button
    // (data-sold-out), leave it alone. Otherwise sync the price text.
    const cta = el('mainCta');
    if (cta && !cta.dataset.soldOut) {
      cta.textContent = `Add to Cart — ${fmt(ctaPrice)}`;
    }

    const variantLabel = purchaseMode === 'subscription'
      ? `${selectedPack.label} · Subscribe & Save`
      : `${selectedPack.label} · One-Time Purchase`;
    if (el('cartItemVariant')) el('cartItemVariant').textContent = variantLabel;
    if (el('cartItemPrice')) el('cartItemPrice').textContent = fmt(ctaPrice);
    updateCartSubtotal();
  }

  function selectPurchaseMode(mode) {
    purchaseMode = mode;
    const subBody = document.querySelector('.sub-body');
    const oneTime = document.querySelector('.one-time');
    if (!subBody || !oneTime) return;
    const subRadio = subBody.querySelector('.sub-radio');
    const otRadio = oneTime.querySelector('.sub-radio');
    if (mode === 'subscription') {
      subBody.classList.remove('deselected');
      subRadio.classList.add('selected');
      otRadio.classList.remove('selected');
      oneTime.classList.remove('selected');
    } else {
      subBody.classList.add('deselected');
      subRadio.classList.remove('selected');
      otRadio.classList.add('selected');
      oneTime.classList.add('selected');
    }
    syncPrices();
  }

  // Preview-only subtotal for the pack/sub mode UI. Does NOT touch the
  // header cart badge — that only reflects the real Shopify cart, which is
  // written by renderCart() and the initial /cart.js fetch below. Writing
  // cartQty here would make the badge show "1" the moment someone just taps
  // a pack or purchase-mode box without actually adding anything to the cart.
  function updateCartSubtotal() {
    const base = purchaseMode === 'subscription' ? selectedPack.price * 0.80 : selectedPack.price;
    const subtotal = +(base * cartQty).toFixed(2);
    if (el('cartSubtotal')) el('cartSubtotal').textContent = fmt(subtotal);
  }

  window.updateCartQty = function (delta) {
    cartQty = Math.max(1, cartQty + delta);
    if (el('cartQty')) el('cartQty').textContent = cartQty;
    updateCartSubtotal();
  };

  /* ────────── Overlays ────────── */
  window.openNutrition = function () {
    el('nutritionOverlay')?.classList.add('open');
    el('nutritionPanel')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeNutrition = function () {
    el('nutritionOverlay')?.classList.remove('open');
    el('nutritionPanel')?.classList.remove('open');
    document.body.style.overflow = '';
  };

  function openCartPanelOnly() {
    el('cartOverlay')?.classList.add('open');
    el('cartPanel')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  window.openCart = async function () {
    openCartPanelOnly();
    await renderCart();
  };
  window.closeCart = function () {
    el('cartOverlay')?.classList.remove('open');
    el('cartPanel')?.classList.remove('open');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeNutrition(); closeCart(); }
  });

  /* ────────── Real Shopify cart integration ────────── */
  // Cart drawer gets Shopify /cart.js responses in CENTS. Format using the shop's
  // money format so the drawer currency matches the storefront's active market.
  function money(cents) { return fmt((Number(cents) || 0) / 100); }

  async function fetchCart() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return r.ok ? r.json() : null;
    } catch (e) { return null; }
  }

  async function renderCart() {
    // Write only into #cartItems so the "Pair it with" upsell (sibling inside
    // .cart-body) survives refreshes. .cart-body itself is the scroll
    // container that holds items + upsell together.
    const items = el('cartItems');
    const foot = el('cartFoot');
    if (!items || !foot) return;
    const cart = await fetchCart();
    const badges = document.querySelectorAll('.cart-count');

    if (!cart) {
      items.innerHTML = '<div class="cart-empty" style="text-align:center;padding:60px 20px;color:var(--sw-text-muted)">Cart unavailable. Please refresh.</div>';
      foot.style.display = 'none';
      return;
    }

    badges.forEach(b => b.textContent = cart.item_count);
    if (el('cartItemCount')) el('cartItemCount').textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';

    if (!cart.items || cart.items.length === 0) {
      items.innerHTML = '<div class="cart-empty" style="text-align:center;padding:60px 20px;color:var(--sw-text-muted)"><div style="font-size:48px;margin-bottom:16px">🛒</div>Your cart is empty.<br><a href="/collections/all" style="color:var(--sw-primary);text-decoration:underline;margin-top:12px;display:inline-block;font-weight:600">Continue shopping</a></div>';
      foot.style.display = 'none';
      return;
    }

    foot.style.display = 'block';
    if (el('cartSubtotal')) el('cartSubtotal').textContent = money(cart.total_price);

    items.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-img">
          ${item.image ? `<img src="${item.image.replace(/\\.(jpg|png|jpeg|webp)/, '_144x.$1')}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:inherit">` : '⚱︎'}
        </div>
        <div>
          <div class="cart-item-title">${item.product_title || item.title || ''}</div>
          <div class="cart-item-variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item-qty">
            <button type="button" onclick="updateItemQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button type="button" onclick="updateItemQty('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:10px">
          <div class="cart-item-price">
            ${item.original_line_price > item.line_price ? `<span class="cart-item-price-was">${money(item.original_line_price)}</span>` : ''}
            <span class="cart-item-price-now">${money(item.line_price)}</span>
          </div>
          <button type="button" class="cart-item-remove" onclick="removeItem('${item.key}')" aria-label="Remove" title="Remove">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 17 6"/><path d="M8 6V4a2 2 0 012-2h0a2 2 0 012 2v2m2 0v12a2 2 0 01-2 2H8a2 2 0 01-2-2V6"/><line x1="9" y1="10" x2="9" y2="16"/><line x1="12" y1="10" x2="12" y2="16"/></svg>
          </button>
        </div>
      </div>
    `).join('');

    // "Add another at 20% off" nudge — only when cart has exactly 1 item with qty 1.
    // Discount is applied by a Shopify automatic Buy-X-Get-Y rule the merchant sets up.
    if (cart.items.length === 1 && cart.items[0].quantity === 1) {
      const it = cart.items[0];
      const discounted = Math.round(it.price * 0.80);
      const imgHtml = it.image
        ? `<img src="${it.image.replace(/\.(jpg|png|jpeg|webp)/, '_120x.$1')}" alt="${(it.product_title || it.title || '').replace(/"/g, '&quot;')}">`
        : '<span class="cart-second-item-img-placeholder">⚱︎</span>';
      items.insertAdjacentHTML('beforeend', `
        <div class="cart-second-item" role="region" aria-label="Add a second bottle at 20% off">
          <div class="cart-second-item-img">${imgHtml}</div>
          <div class="cart-second-item-copy">
            <span class="cart-second-item-badge">SAVE 20% ON THE SECOND</span>
            <div class="cart-second-item-title">Add another ${it.product_title || it.title || 'bottle'}</div>
            <div class="cart-second-item-pricing">
              <span class="cart-second-item-price">${money(discounted)}</span>
              <span class="cart-second-item-original">${money(it.price)}</span>
            </div>
          </div>
          <button type="button" class="cart-second-item-cta" onclick="swAddSecond(${it.variant_id}, this)">
            + Add
          </button>
        </div>
      `);
    }
  }

  // Add a second unit of the same line. Uses /cart/change.js on the existing
  // line's key to guarantee it merges (quantity+1), rather than /cart/add.js
  // which can create a second line when envelopes differ. Shopify's automatic
  // discount then applies to the merged line at checkout.
  window.swAddSecond = async function (variantId, btn) {
    const prev = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';
    try {
      const cart = await fetchCart();
      const line = (cart && cart.items || []).find(i => i.variant_id === variantId);
      if (line) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity + 1 })
        });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      }
      await renderCart();
    } catch (e) {
      console.error('swAddSecond', e);
      btn.disabled = false;
      btn.innerHTML = prev;
    }
  };

  async function changeCart(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, parseInt(qty) || 0) })
    });
    // On the full /cart page, reload to re-render server-side totals + rows.
    if (location.pathname === '/cart' || location.pathname.endsWith('/cart/')) {
      location.reload();
    } else {
      await renderCart();
    }
  }

  window.updateItemQty = function (key, qty) { return changeCart(key, qty).catch(e => console.error('qty', e)); };
  window.removeItem   = function (key)      { return changeCart(key, 0  ).catch(e => console.error('rm', e)); };

  // Read the currently-selected Appstle selling-plan ID from the active ship-pill.
  // Returns null if we're in one-time mode or no pill is selected.
  function currentSellingPlanId() {
    if (purchaseMode !== 'subscription') return null;
    const pill = document.querySelector('.ship-pill.selected');
    const raw = pill && pill.dataset && pill.dataset.plan;
    if (!raw) return null;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  window.handleAddToCart = async function () {
    const cta = el('mainCta');
    const variantId = cta?.dataset.variantId;
    if (!variantId) {
      // Theme-editor / demo mode — just open the drawer
      openCartPanelOnly();
      await renderCart();
      return;
    }
    const originalText = cta.textContent;
    cta.disabled = true;
    cta.textContent = 'Adding…';
    try {
      const item = { id: variantId, quantity: selectedPack.qty || 1 };
      const planId = currentSellingPlanId();
      if (planId) item.selling_plan = planId;
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        // Common Appstle failure: product isn't attached to the selling-plan group yet.
        const msg = err.description || err.message || 'Add failed';
        throw new Error(msg);
      }
      openCartPanelOnly();
      await renderCart();
    } catch (e) {
      alert('Could not add to cart: ' + e.message);
    } finally {
      cta.disabled = false;
      cta.textContent = originalText;
    }
  };

  // Keep header cart badge fresh on load
  window.addEventListener('load', () => {
    fetchCart().then(cart => {
      if (cart) document.querySelectorAll('.cart-count').forEach(b => b.textContent = cart.item_count);
    });
  });

  /* ────────── Gallery zoom: hover-magnifier (desktop) + lightbox (all) ────────── */
  function initGalleryZoom() {
    const main = document.getElementById('galleryMain');
    if (!main) return;
    const img = main.querySelector('img');
    if (!img) return;

    // Hover-magnifier: scale 2.2x following the cursor.
    // Disabled automatically on touch via the CSS @media hover query — the
    // transform class is set here either way; CSS decides whether to apply it.
    main.addEventListener('mouseenter', () => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        main.classList.add('zooming');
      }
    });
    main.addEventListener('mouseleave', () => {
      main.classList.remove('zooming');
      img.style.transformOrigin = '';
    });
    main.addEventListener('mousemove', (e) => {
      if (!main.classList.contains('zooming')) return;
      const r = main.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
    });

    // Touch swipe: swipe left/right on the main image to navigate through
    // thumbnails. We flag `_swipedJustNow` on touchend when the gesture was a
    // real swipe; the inline onclick="openLightbox()" handler checks that flag
    // and bails. This avoids relying on preventDefault() to suppress the
    // synthetic click (which is unreliable across browsers).
    let touchStartX = null, touchStartY = null, touchMovedX = 0, touchMovedY = 0;
    const SWIPE_THRESHOLD = 40;   // px of horizontal movement to count as swipe

    main.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchMovedX = 0;
      touchMovedY = 0;
      window._swipedJustNow = false;
    }, { passive: true });

    main.addEventListener('touchmove', (e) => {
      if (touchStartX === null) return;
      touchMovedX = e.touches[0].clientX - touchStartX;
      touchMovedY = e.touches[0].clientY - touchStartY;
    }, { passive: true });

    main.addEventListener('touchend', () => {
      if (touchStartX === null) return;
      const absX = Math.abs(touchMovedX);
      const absY = Math.abs(touchMovedY);
      // Horizontal swipe wins only if horizontal distance > threshold AND
      // more horizontal than vertical (otherwise it's a vertical page scroll).
      if (absX > SWIPE_THRESHOLD && absX > absY) {
        window._swipedJustNow = true;
        swipeGallery(touchMovedX < 0 ? 1 : -1);
        // Clear the flag after the synthetic click fires
        setTimeout(() => { window._swipedJustNow = false; }, 400);
      }
      touchStartX = null; touchStartY = null;
    });
  }

  function swipeGallery(delta) {
    const thumbs = Array.from(document.querySelectorAll('.gallery-thumb[data-full]'));
    if (thumbs.length < 2) return;
    let idx = thumbs.findIndex(t => t.classList.contains('active'));
    if (idx < 0) idx = 0;
    const next = (idx + delta + thumbs.length) % thumbs.length;
    thumbs[next].click();           // reuses the existing active-swap + src update
    // Scroll the new thumb into view so the horizontal thumb strip tracks it
    thumbs[next].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryZoom);
  } else {
    initGalleryZoom();
  }

  // Lightbox state. Images list is built from the gallery thumbnail buttons
  // (each has data-full with the high-res URL). On the first open, we snapshot
  // the list so thumb navigation keeps working.
  let _lbIndex = 0;
  let _lbImages = [];
  function _rebuildLightboxImages() {
    const thumbs = document.querySelectorAll('.gallery-thumb[data-full]');
    _lbImages = Array.from(thumbs).map(t => ({
      full: t.dataset.full,
      alt:  t.getAttribute('aria-label') || ''
    }));
    const activeIdx = Array.from(thumbs).findIndex(t => t.classList.contains('active'));
    _lbIndex = activeIdx >= 0 ? activeIdx : 0;
    // Fallback: use main image if no thumbs
    if (_lbImages.length === 0) {
      const mainImg = document.querySelector('.gallery-main img');
      if (mainImg) _lbImages = [{full: mainImg.src, alt: mainImg.alt || ''}];
    }
  }
  function _renderLightboxImage() {
    const img = document.getElementById('swLightboxImg');
    const counter = document.getElementById('swLightboxCounter');
    if (!img || !_lbImages.length) return;
    const cur = _lbImages[_lbIndex];
    img.src = cur.full;
    img.alt = cur.alt;
    if (counter) counter.textContent = `${_lbIndex + 1} / ${_lbImages.length}`;
    // Hide nav if only one image
    const prev = document.querySelector('.sw-lightbox-prev');
    const next = document.querySelector('.sw-lightbox-next');
    const show = _lbImages.length > 1 ? '' : 'none';
    if (prev) prev.style.display = show;
    if (next) next.style.display = show;
  }
  window.openLightbox = function (e) {
    // If the user just swiped on the gallery, suppress the synthetic click
    // that would otherwise open the lightbox.
    if (window._swipedJustNow) return;
    if (e && e.target && e.target.closest && e.target.closest('.gallery-thumb, .gallery-thumb-nav')) return;
    const box = document.getElementById('swLightbox');
    if (!box) return;
    _rebuildLightboxImages();
    _renderLightboxImage();
    box.classList.add('open');
    box.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  window.closeLightbox = function (e) {
    // If called via overlay click, only close when clicking the overlay itself
    // (not an inner button). Direct calls (from X button) pass no event.
    if (e && e.target && e.target.id !== 'swLightbox') return;
    const box = document.getElementById('swLightbox');
    if (!box) return;
    box.classList.remove('open');
    box.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  window.lightboxNav = function (delta, e) {
    if (e) e.stopPropagation();
    if (!_lbImages.length) return;
    _lbIndex = (_lbIndex + delta + _lbImages.length) % _lbImages.length;
    _renderLightboxImage();
  };
  // Keyboard: Esc closes, arrows navigate
  document.addEventListener('keydown', (e) => {
    const box = document.getElementById('swLightbox');
    if (!box || !box.classList.contains('open')) return;
    if (e.key === 'Escape') window.closeLightbox();
    if (e.key === 'ArrowRight') window.lightboxNav(1);
    if (e.key === 'ArrowLeft')  window.lightboxNav(-1);
  });

  /* ────────── Cart upsell one-click add ──────────
     Buttons rendered by sw-cart-upsell.liquid call this with their
     data-variant-id. Posts to /cart/add.js, then refreshes either the
     drawer (if open) or the full /cart page (if that's what we're on). */
  window.swOneClickAdd = async function (btn) {
    if (!btn || !btn.dataset || !btn.dataset.variantId) return;
    const vid = parseInt(btn.dataset.variantId, 10);
    if (!vid) return;
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="sw-upsell-add-plus">…</span> Adding';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Add failed');
      }
      btn.innerHTML = '<span class="sw-upsell-add-plus">✓</span> Added';
      // Drawer open? Re-render it. Else on /cart? Reload. Else just update badge.
      const drawer = document.getElementById('cartPanel');
      if (drawer && drawer.classList.contains('open')) {
        await renderCart();
      } else if (location.pathname === '/cart' || location.pathname.endsWith('/cart/')) {
        location.reload();
      } else {
        const cart = await fetchCart();
        if (cart) document.querySelectorAll('.cart-count').forEach(b => b.textContent = cart.item_count);
      }
      setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 1600);
    } catch (e) {
      btn.innerHTML = '<span class="sw-upsell-add-plus">!</span> Error';
      setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
      console.error('upsell add', e);
    }
  };

  // Mobile sticky CTA — show ONLY after user has scrolled past the main CTA
  function initStickyCta() {
    const mainCta = document.getElementById('mainCta');
    const sticky = document.getElementById('mobileStickyCta');
    if (!mainCta || !sticky) return;

    document.body.classList.add('has-sticky-cta');

    function check() {
      const rect = mainCta.getBoundingClientRect();
      // Show when the entire CTA has scrolled above the viewport (user is past it)
      // Hide when any part of CTA is still visible OR below the viewport
      const scrolledPast = rect.bottom < 0;
      sticky.classList.toggle('visible', scrolledPast);
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCta);
  } else {
    initStickyCta();
  }

  // FAQ toggle + See More buttons — event delegation (bulletproof)
  document.addEventListener('click', (e) => {
    // FAQ accordion: toggle this item, close siblings so only one is ever open.
    const faqBtn = e.target.closest('.faq-question');
    if (faqBtn && faqBtn.parentElement) {
      const item = faqBtn.parentElement;
      const list = item.parentElement;
      const willOpen = !item.classList.contains('open');
      if (list) list.querySelectorAll('.faq-item.open').forEach(it => {
        it.classList.remove('open');
        const btn = it.querySelector('.faq-question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        item.classList.add('open');
        faqBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    // See more product reviews
    if (e.target.closest('#productSeeMore')) {
      const list = document.getElementById('productReviewList');
      if (list) {
        list.querySelectorAll('.widget-review.hidden').forEach(r => r.classList.remove('hidden'));
        const shown = document.getElementById('productShown');
        if (shown) shown.textContent = list.querySelectorAll('.widget-review').length;
      }
      const btn = document.getElementById('productSeeMore');
      if (btn) btn.style.display = 'none';
      return;
    }
    // See more store reviews
    if (e.target.closest('#storeSeeMore')) {
      const list = document.getElementById('storeReviewList');
      if (list) {
        list.querySelectorAll('.widget-review.hidden').forEach(r => r.classList.remove('hidden'));
        const shown = document.getElementById('storeShown');
        if (shown) shown.textContent = list.querySelectorAll('.widget-review').length;
      }
      const btn = document.getElementById('storeSeeMore');
      if (btn) btn.style.display = 'none';
      return;
    }
  });

  // Scroll thumbnail strip by one page, clamped so we never scroll past
  // the end — that was leaving empty space on mobile and requiring N presses
  // on the opposite arrow to get back.
  window.scrollThumbs = function (direction) {
    const strip = document.getElementById('galleryThumbs');
    if (!strip) return;
    const thumb = strip.querySelector('.gallery-thumb');
    if (!thumb) return;
    const isHorizontal = window.innerWidth <= 900;
    const thumbSize = (isHorizontal ? thumb.getBoundingClientRect().width : thumb.getBoundingClientRect().height) + 10;
    const amount = direction * thumbSize * 3;
    if (isHorizontal) {
      const max = strip.scrollWidth - strip.clientWidth;
      const target = Math.max(0, Math.min(max, strip.scrollLeft + amount));
      strip.scrollTo({ left: target, behavior: 'smooth' });
    } else {
      const max = strip.scrollHeight - strip.clientHeight;
      const target = Math.max(0, Math.min(max, strip.scrollTop + amount));
      strip.scrollTo({ top: target, behavior: 'smooth' });
    }
    // Update disabled state on arrows after the scroll settles
    setTimeout(updateThumbNavState, 350);
  };

  function updateThumbNavState() {
    const strip = document.getElementById('galleryThumbs');
    if (!strip) return;
    const prev = document.querySelector('.gallery-thumb-nav-prev');
    const next = document.querySelector('.gallery-thumb-nav-next');
    const isHorizontal = window.innerWidth <= 900;
    const pos = isHorizontal ? strip.scrollLeft : strip.scrollTop;
    const max = isHorizontal ? (strip.scrollWidth - strip.clientWidth)
                             : (strip.scrollHeight - strip.clientHeight);
    const atStart = pos <= 1;
    const atEnd = pos >= max - 1 || max <= 0;
    if (prev) {
      prev.disabled = atStart;
      prev.style.opacity = atStart ? '0.35' : '';
      prev.style.cursor = atStart ? 'default' : '';
    }
    if (next) {
      next.disabled = atEnd;
      next.style.opacity = atEnd ? '0.35' : '';
      next.style.cursor = atEnd ? 'default' : '';
    }
  }
  // Keep arrow state fresh on load, scroll, and resize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateThumbNavState);
  } else {
    updateThumbNavState();
  }
  window.addEventListener('load', updateThumbNavState);
  window.addEventListener('resize', updateThumbNavState);
  (function hookStripScroll() {
    const strip = document.getElementById('galleryThumbs');
    if (!strip) { setTimeout(hookStripScroll, 200); return; }
    strip.addEventListener('scroll', updateThumbNavState, { passive: true });
  })();

  // Sticky-bar click: scroll back to the pack/bundle selector so user can review + add
  window.scrollToBundles = function () {
    const target = document.querySelector('.pack-label') || document.querySelector('.pack-grid') || document.getElementById('mainCta');
    if (!target) { return; }
    const headerH = document.querySelector('.header')?.getBoundingClientRect().height || 70;
    const y = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  /* Read the initially-selected pack card from the DOM so initial prices match actual product price. */
  function initSelectedPackFromDOM() {
    const def = document.querySelector('.pack-card.selected') || document.querySelector('.pack-card');
    if (!def) return;
    const compareText = (def.querySelector('.pack-price-compare')?.textContent || '').replace(/[^0-9.]/g, '');
    selectedPack = {
      qty: parseInt(def.dataset.qty) || 1,
      price: parseFloat(def.dataset.price) || 0,
      label: def.dataset.label || '1 Pack',
      compare: compareText ? parseFloat(compareText) : parseFloat(def.dataset.price || 0),
    };
  }

  /* ────────── Event wiring ────────── */
  function initEvents() {
    initSelectedPackFromDOM();
    document.querySelectorAll('.pack-card').forEach(card => {
      card.addEventListener('click', () => {
        document.querySelectorAll('.pack-card').forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        const compareText = (card.querySelector('.pack-price-compare')?.textContent || '').replace(/[^0-9.]/g, '');
        selectedPack = {
          qty: parseInt(card.dataset.qty) || 1,
          price: parseFloat(card.dataset.price) || 0,
          label: card.dataset.label || '1 Pack',
          compare: compareText ? parseFloat(compareText) : parseFloat(card.dataset.price || 0),
        };
        syncPrices();
      });
    });

    document.querySelector('.sub-body')?.addEventListener('click', e => {
      e.stopPropagation();
      if (e.target.closest('.ship-pill')) return;
      selectPurchaseMode('subscription');
    });
    document.querySelector('.one-time')?.addEventListener('click', e => {
      e.stopPropagation();
      selectPurchaseMode('onetime');
    });

    document.querySelectorAll('.ship-pill').forEach(p => {
      p.addEventListener('click', e => {
        e.stopPropagation();
        document.querySelectorAll('.ship-pill').forEach(x => x.classList.remove('selected'));
        p.classList.add('selected');
      });
    });

    document.querySelectorAll('.gallery-thumb').forEach(t => {
      t.addEventListener('click', () => {
        document.querySelectorAll('.gallery-thumb').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const full = t.dataset.full;
        const mainImg = document.querySelector('.gallery-main img');
        if (mainImg && full) mainImg.src = full;
      });
    });

    /* FAQ accordion — handled by the document-level delegator above.
       Do NOT add per-button listeners here or clicks fire twice. */

    /* Reviews widget tabs */
    document.querySelectorAll('.reviews-widget-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.reviews-widget-tab').forEach(x => x.classList.remove('active'));
        tab.classList.add('active');
        const which = tab.dataset.tab;
        el('tabProduct')?.classList.toggle('hidden', which !== 'product');
        el('tabStore')?.classList.toggle('hidden', which !== 'store');
      });
    });

    /* See more reviews */
    el('productSeeMore')?.addEventListener('click', () => {
      const list = el('productReviewList');
      list?.querySelectorAll('.widget-review.hidden').forEach(r => r.classList.remove('hidden'));
      if (el('productShown')) el('productShown').textContent = list.querySelectorAll('.widget-review').length;
      el('productSeeMore').style.display = 'none';
    });
    el('storeSeeMore')?.addEventListener('click', () => {
      const list = el('storeReviewList');
      list?.querySelectorAll('.widget-review.hidden').forEach(r => r.classList.remove('hidden'));
      if (el('storeShown')) el('storeShown').textContent = list.querySelectorAll('.widget-review').length;
      el('storeSeeMore').style.display = 'none';
    });

    /* Sorting + filter helpers */
    function applyFilters(sortId, ratingId, listId) {
      const sort = el(sortId)?.value || 'latest';
      const ratingFilter = el(ratingId)?.value || 'all';
      const list = el(listId);
      if (!list) return;
      const items = Array.from(list.querySelectorAll('.widget-review'));
      items.forEach(it => {
        const r = it.dataset.rating;
        it.style.display = (ratingFilter === 'all' || r === ratingFilter) ? '' : 'none';
      });
      const visible = items.filter(it => it.style.display !== 'none');
      const comparators = {
        latest: (a, b) => items.indexOf(a) - items.indexOf(b),
        highest: (a, b) => parseInt(b.dataset.rating) - parseInt(a.dataset.rating),
        lowest: (a, b) => parseInt(a.dataset.rating) - parseInt(b.dataset.rating),
      };
      visible.sort(comparators[sort] || comparators.latest);
      visible.forEach(it => list.appendChild(it));
    }
    el('productSort')?.addEventListener('change', () => applyFilters('productSort', 'productRating', 'productReviewList'));
    el('productRating')?.addEventListener('change', () => applyFilters('productSort', 'productRating', 'productReviewList'));
    el('storeSort')?.addEventListener('change', () => applyFilters('storeSort', 'storeRating', 'storeReviewList'));
    el('storeRating')?.addEventListener('change', () => applyFilters('storeSort', 'storeRating', 'storeReviewList'));

    /* Trusted-by carousel */
    (function initTrustedCarousel() {
      const track = el('trustedTrack');
      if (!track) return;
      const prevBtn = el('trustedPrev');
      const nextBtn = el('trustedNext');
      const dotsWrap = el('trustedDots');
      let position = 0;
      let pageSize = 4;

      function perPage() {
        const w = window.innerWidth;
        if (w <= 560) return 1;
        if (w <= 800) return 2;
        if (w <= 1100) return 3;
        return 5;
      }
      function buildDots() {
        pageSize = perPage();
        const total = track.children.length;
        const pages = Math.max(1, Math.ceil(total / pageSize));
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          for (let i = 0; i < pages; i++) {
            const b = document.createElement('button');
            b.className = 'trusted-dot' + (i === 0 ? ' active' : '');
            b.addEventListener('click', () => go(i));
            dotsWrap.appendChild(b);
          }
        }
      }
      function go(page) {
        const total = track.children.length;
        const pages = Math.max(1, Math.ceil(total / pageSize));
        position = Math.max(0, Math.min(page, pages - 1));
        const cardWidth = track.children[0].getBoundingClientRect().width;
        const gap = 20;
        const offset = position * pageSize * (cardWidth + gap);
        track.style.transform = `translateX(-${offset}px)`;
        document.querySelectorAll('.trusted-dot').forEach((d, i) => d.classList.toggle('active', i === position));
        if (prevBtn) prevBtn.disabled = position === 0;
        if (nextBtn) nextBtn.disabled = position === pages - 1;
      }
      prevBtn?.addEventListener('click', () => go(position - 1));
      nextBtn?.addEventListener('click', () => go(position + 1));
      window.addEventListener('resize', () => { buildDots(); go(0); });
      buildDots();
      go(0);
    })();

    syncPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEvents);
  } else {
    initEvents();
  }
})();
